<router-outlet></router-outlet>

<app-progress-spinner-demo> </app-progress-spinner-demo>

@if (showInitialLoading()) {
  <div id="app-loading-indicator">
    <img class="spinner" src="assets/icons/load-icon.svg" alt="" />
  </div>
}
